import { service } from '../../../../helpers/http' 

export const ActionPostCheckEmail = ({ dispatch }, payload) => {
    return service({
        module: 'domainAccessLogin',
        action: 'postCheckEmail',
        payload: payload
    })
}